const product = [{
  desc: '查询列表接口',
  options: {
    url: '/product/queryList',
    method: 'get',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '删除',
  options: {
    url: '/product/delete',
    method: 'delete',
    baseURL: '/sxcore/api',
    argsParams: true
  },
  vuex: false
}, {
  desc: '新增/修改',
  options: {
    url: '/product/add',
    method: 'post',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '详情',
  options: {
    url: '/product/detail',
    method: 'get',
    baseURL: '/sxcore/api',
    argsParams: true
  },
  vuex: false
}, {
  desc: '保险公司列表',
  options: {
    url: '/company',
    method: 'get',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '查询产品列表',
  options: {
    url: '/product/queryLifeProductList',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-product'
  },
  vuex: false
}, {
  desc: '查询产品基础字典',
  options: {
    url: '/dict/queryProductBaseDict',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-product'
  },
  vuex: true
}, {
  desc: '查询产品基础字典',
  options: {
    url: '/busiDict/queryBusiDictsForSalesmanLevel',
    method: 'post'
  },
  vuex: true
}, {
  desc: '产品库产品详情',
  options: {
    url: '/product/productDatabaseDetail',
    method: 'post',
    baseURL: '/sxcore/api',
    argsParams: true
  },
  vuex: false
}, {
  desc: '产品库产品列表',
  options: {
    url: '/product/productDatabaseList',
    method: 'post',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '查询产品属性枚举',
  options: {
    url: '/product/queryProductAttribute',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-product'
  },
  vuex: true
}, {
  desc: '导出',
  options: {
    url: '/product/export',
    method: 'get',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '导出任务列表',
  options: {
    url: '/export/selectbytime',
    method: 'post',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '产品库产品详情',
  options: {
    url: '/export/del',
    method: 'get',
    baseURL: '/sxcore/api',
    argsParams: true
  },
  vuex: false
}, {
  desc: '产品库产品详情',
  options: {
    url: '/export/downloadInfo',
    method: 'get',
    baseURL: '/sxcore/api',
    responseType: 'arraybuffer'
  },
  vuex: false
}, {
  desc: '保险公司授权列表',
  options: {
    url: '/userInsbranch',
    method: 'get',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '保险公司授权列表导出',
  options: {
    url: '/userInsbranch/export',
    method: 'get',
    baseURL: '/sxcore/api',
    responseType: 'arraybuffer'
  },
  vuex: false
}, {
  desc: '保险公司授权',
  options: {
    url: '/userInsbranch',
    method: 'post',
    baseURL: '/sxcore/api'
  },
  vuex: false
}, {
  desc: '保司授权列表查询',
  options: {
    url: '/sysUserInsBranch/getSysInsBranchList',
    method: 'post'
  },
  vuex: false
}, {
  desc: '保司授权',
  options: {
    url: '/sysUserInsBranch/userInsBranch',
    method: 'post'
  },
  vuex: false
}, {
  desc: '通过产品库新增产品',
  options: {
    url: '/productFc/addProductByDataBase',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '自定义产品',
  options: {
    url: '/productFc/addCustomProduct',
    method: 'post'
  },
  vuex: false
}, {
  desc: '商户端 商户删除产品',
  options: {
    url: '/productFc/deleteUserProduct',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '商户端 商户查询产品库列表',
  options: {
    url: '/productFc/queryProductDataBaseListForNonCar',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '商户端 商户产品列表查询',
  options: {
    url: '/productFc/getProductList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '商户端 商户产品上下架',
  options: {
    url: '/productFc/batchUpdateStatus',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '查询产品信息',
  options: {
    url: '/productFc/queryProductDetails',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '查询产品关联的商品信息',
  options: {
    url: '/commodifyInfo/queryCommodifyInfo',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '上传',
  options: {
    url: '/common/upload',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '商户端 商户修改产品',
  options: {
    url: '/productFc/updateUserProduct',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '商户端 查询保司下拉选',
  options: {
    url: '/productFc/queryCompanys',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '商城分类列表',
  options: {
    url: '/commodifyType/list',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '商城分类字典数据',
  options: {
    url: '/commodifyType/queryCommodifyTypes',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '保存商城分类',
  options: {
    url: '/commodifyType/save',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '编辑商城分类',
  options: {
    url: '/commodifyType/update',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '更新商城分类状态',
  options: {
    url: '/commodifyType/updateStatus',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '识别二维码',
  options: {
    url: '/common/qrCodeDecode',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '查询投保方式列表',
  options: {
    url: '/commodifyInfo/queryInsureTypes',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '新增/编辑商品基本信息及销售配置',
  options: {
    url: '/commodifyInfo/addOrUpdateCommodifyConfig',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '删除商品及关联信息',
  options: {
    url: '/commodifyInfo/deleteCommodifyInfo',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '新增/编辑商品基本信息及销售配置（第一步）',
  options: {
    url: '/productFc/addOrUpdateCommodifyConfig',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  }
}, {
  desc: '新增/编辑商品基本信息及销售配置（第二步）',
  options: {
    url: '/commodifyInfo/addOrUpdateInsureTypeConfig',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '查询渠道信息',
  options: {
    url: '/commodifyInfo/queryShareUrls',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '根据渠道查询分享投保链接和二维码',
  options: {
    url: '/insureUrlData/queryShareUrlByChannel',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '生成二维码',
  options: {
    url: '/insureUrlData/createQrCode',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '生成分享链接',
  options: {
    url: '/insureUrlData/createShareUrl',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '导入保司配置',
  options: {
    url: '/commodifyInfo/importCompanyConfig',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '导入保司配置',
  options: {
    url: '/upload/uploadProductFile',
    method: 'post'
  }
}, {
  desc: '导出分享链接',
  options: {
    url: '/insureUrlData/exportInsureUrlData',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure',
    responseType: 'arraybuffer'
  }
}, {
  desc: '链接投保列表查询',
  options: {
    url: '/commodifyInfo/queryInsureConfigsForPage',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '链接投保单个新增/编辑',
  options: {
    url: '/commodifyInfo/addOrUpdateInsureConfig',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '链接投保单个删除',
  options: {
    url: '/commodifyInfo/deleteInsureUrlConfig',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '查询禁用机构/已选机构',
  options: {
    url: '/commodifyInfo/queryChannelsForUrl',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '查询禁用机构/已选机构(含个单团做)',
  options: {
    url: '/commodifyInfo/queryChannelsForUrlAndSingleGroup',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '渠道或个人获取二维码',
  options: {
    url: '/insureUrlData/createShareUrl',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '二维码批量下载',
  options: {
    url: '/insureUrlData/batchDownload',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure',
    responseType: 'arraybuffer'
  },
  vuex: false
}, {
  desc: '获取人员',
  options: {
    url: '/customer/queryCustomersForOrgAndCustomer',
    method: 'post'
    // baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '查询产品、商品信息',
  options: {
    url: '/productFc/queryProductNonVehicleInfos',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '获取投保载体字典数据',
  options: {
    url: '/productInsure/querySupporters',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  },
  vuex: false
}, {
  desc: '动态查询二维码类型',
  options: {
    url: '/commodifyInfo/queryQrCodeTypes',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  },
  vuex: false
}, {
  desc: '产品-商品分类',
  options: {
    url: '/shoping/commodifyType',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify/'
  }
}, {
  desc: '产品-推广服务商管理',
  options: {
    url: '/promotion/queryProductPlatformPromotions',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '立即推广',
  options: {
    url: '/promotion/syncProduct',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '停止推广',
  options: {
    url: '/productFc/batchUpdateStatus',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '产品-获取签约人列表',
  options: {
    url: '/customer/getCustomerForProduct',
    method: 'post'
    // baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '产品-获取跳转签字url二维码',
  options: {
    url: '/promotion/jumpSignInfoUrlQrCode',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '产品-签约详情',
  options: {
    url: '/promotion/querySignDetail',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '产品-签约的图片获取',
  options: {
    url: '/customer/queryDistributorPartnerSignPicture',
    method: 'get',
    baseURL: '/openapi/api/runbao'
  },
  vuex: false
}, {
  desc: '产品详情',
  options: {
    url: '/promotion/productDetail',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform'
  },
  vuex: false
}, {
  desc: '产品详情-批量下载资料',
  options: {
    url: '/promotion/batchDownload',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-product-platform',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json; application/octet-stream'
    }
  },
  vuex: false
}]
export default product



// WEBPACK FOOTER //
// ./src/api/product.js